// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"CoursePage_wrapper__1X4d","info":"CoursePage_info__1WGu","infoText":"CoursePage_infoText__WXCd","code":"CoursePage_code__2Yva","title":"CoursePage_title__1loT","description":"CoursePage_description__12c5","reviewsWrapper":"CoursePage_reviewsWrapper__3TOO","graphs":"CoursePage_graphs__3mnd","sectionTitle":"CoursePage_sectionTitle__DrCa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/CoursePage/CoursePage.scss
// module id = 1056
// module chunks = 0